<template>
    <div class="search-header">
        <h1 class="search-header__title h2" v-if="title" v-html="title"/>
        <span class="search-header__input-wrapper">
        <input :value="searchString && searchString"
             @keyup.enter="changeHandler"
             type="text"
             class="search-header__input"
             :aria-label="$t('message.searchInput')"
             inputmode="search"
             ref="input" />
            <SearchSpinner :loading="loading" />
        </span>
        <input
            type="button"
            @click="changeHandler"
            class="search-header__button btn btn-primary js-ripple"
            value="zoeken" />
    </div>
</template>

<script>
import SearchSpinner from './search-spinner';

export default {
    props: {
        searchString: {
            type: String,
            required: false,
            default: null
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        changeHandler( e ) {
            const { value } = this.$refs.input;
            this.$emit( 'change', value );
        }
    },
    computed: {
        title() {
            return wp_variables.search.you_searched_for_label;
        }
    },
    components: {
        SearchSpinner,
    }
};
</script>
